import { regexErrors, regexes, regexPlaceholders } from "./helper.js";
export let data = {
  title: "Input Pemeriksaan Perawat",
  backBtn: "/ranap",
  actionBtn: [],
  breadcrumb: [
    { title: "Rawat Inap", link: "/ranap" },
    { title: "Detail Rawat Inap", link: "/ranap" },
    { title: "Input Pemeriksaan Perawat", active: true },
  ],
};
export let detailTop = {
  picture: "https://randomuser.me/api/portraits/men/97.jpg",
  topSubtitle: "",
  title: "Ahmad Subekti",
  subtitle: "No RM : 12345 | Pasien Peserta BPJS",
  items: [
    { icon: "wc", content: "Laki-laki" },
    { icon: "phone", content: "0897-2020-9090" },
  ],
  topRight: [
    {
      key: 1,
      columns: [
        {
          colnum: 5,
          icon: "today",
          label: "TANGGAL LAHIR",
          content: "20 Des 1990 (30 th)",
        },
        {
          colnum: 7,
          icon: "",
          label: "PENANGGUNG JAWAB",
          content: "Rina Gunawan (Ibu)",
        },
      ],
    },
    {
      key: 1,
      columns: [
        { colnum: 5, icon: "wb_sunny", label: "AGAMA", content: "Islam" },
        {
          colnum: 7,
          icon: "place",
          label: "",
          content:
            "Jl. Bangau 7 no. 180, RT 003/009 \nPerumnas Depok I Kel. Depok Jaya, \nKec. Pancoran Mas Depok, Jawa Barat",
        },
      ],
    },
  ],
};

export let detailLeftTop = [
  {
    key: String(Math.random(1023)),
    columns: [
      {
        label: "No. Rawat",
        content: "2020/04/16/000001",
        icon: "apps",
        colwidth: 6,
      },
      {
        label: "Unit",
        content: "MAT | Poliklinik Mata",
        icon: "apps",
        colwidth: 6,
      },
    ],
  },
];
export let detailRightTop = [
  {
    label: "Dokter yang Dituju",
    content: "D00000026  |   dr. Azizah Masthura",
    icon: "apps",
  },
];
export let today = new Date();
import { getTime } from "./helper.js";
export let time = getTime(today.getHours(), today.getMinutes());
export let upperForm = [
  {
    colnum: 3,
    columns: [
      {
        label: "Tanggal Periksa",
        type: "date",
        placeholder: "Pilih tanggal periksa",
        name: "tgl_periksa",
        value: today,
        mandatory: true,
        additional: "",
        colwidth: "3",
      },
      {
        label: "Jam",
        type: "time",
        placeholder: "jj:mm",
        name: "jam_periksa",
        value: time,
        mandatory: true,
        additional: "",
        colwidth: "2",
      },
      {
        label: "Perawat Pemeriksa",
        type: "select",
        placeholder: "Perawat Pemeriksa",
        name: "id_petugas",
        value: "",
        mandatory: true,
        multiple: false,
        options: [
          {
            label: "P0000026 | Anggriani Ginting",
            value: "P0000026",
          },
        ],
        additional: "",
        colwidth: 4,
      },
    ],
  },
];
export let formVital = [
  {
    colnum: 2,
    columns: [
      {
        label: "Suhu Badan",
        type: "addon-right",
        addon: "°C",
        regex: regexes.suhu,
        regexError: regexErrors.suhu,
        placeholder: regexPlaceholders.suhu,
        name: "suhu",
        value: "",
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
      {
        label: "Tekanan Darah",
        type: "addon-right",
        addon: "mmhg",
        addonType: "text",
        regex: regexes.tkn_darah,
        regexError: regexErrors.tkn_darah,
        placeholder: regexPlaceholders.tkn_darah,
        name: "tkn_darah",
        value: ``,
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
    ],
  },
  {
    colnum: 2,
    columns: [
      {
        label: "Nadi",
        type: "addon-right",
        addon: "x/menit",
        regex: regexes.nadi,
        regexError: regexErrors.nadi,
        placeholder: regexPlaceholders.nadi,
        name: "nadi",
        value: "",
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
      {
        label: "Respirasi",
        type: "addon-right",
        addon: "x/menit",
        regex: regexes.respirasi,
        regexError: regexErrors.respirasi,
        placeholder: regexPlaceholders.respirasi,
        name: "respirasi",
        value: "",
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "GDSE",
        type: "addon-right",
        addon: "mg/dL",
        regex: regexes.gds,
        regexError: regexErrors.gds,
        placeholder: regexPlaceholders.gds,
        name: "gdse",
        value: "",
        mandatory: true,
        additional: "",
        colwidth: "5",
      },
    ],
  },
];
export let formGizi = [
  {
    colnum: 2,
    columns: [
      {
        label: "Berat Badan",
        type: "addon-right",
        addon: "kg",
        regex: regexes.berat,
        regexError: regexErrors.berat,
        placeholder: regexPlaceholders.berat,
        name: "berat",
        value: "",
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
      {
        label: "Tinggi Badan",
        type: "addon-right",
        addon: "cm",
        regex: regexes.tinggi,
        regexError: regexErrors.tinggi,
        placeholder: regexPlaceholders.tinggi,
        name: "tinggi",
        value: "",
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
    ],
  },
];
export let formFungsional = [
  {
    colnum: 1,
    columns: [
      {
        label: "Alat Bantu",
        type: "text",
        placeholder: "Masukkan alat bantu yang digunakan",
        name: "alat_bantu",
        value: "",
        mandatory: false,
        optional: true,
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Prothesa",
        type: "text",
        placeholder: "Masukkan prothesa",
        name: "prothesa",
        value: "",
        mandatory: false,
        optional: true,
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Cacat Tubuh",
        type: "text",
        placeholder: "Cacat tubuh yang dimiliki",
        name: "cct_tubuh",
        value: "",
        mandatory: false,
        optional: true,
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "ADL",
        type: "radio",
        placeholder: "",
        name: "adl",
        value: "Mandiri",
        defaultValue: "Mandiri",
        mandatory: true,
        multiple: false,
        options: [
          {
            label: "Mandiri",
            value: "Mandiri",
          },
          {
            label: "Dibantu",
            value: "Dibantu",
          },
        ],
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "RPD",
        type: "textarea",
        regex: /^.{0,255}$/,
        regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "max. 255 karakter",
        name: "rpd",
        value: "",
        mandatory: false,
        optional: true,
        additional: "",
      },
    ],
  },
];

export let formAlergi = [
  {
    colnum: 1,
    columns: [
      {
        label: "Obat",
        type: "text",
        placeholder: "Isi jika memiliki alergi obat",
        name: "alg_obat",
        value: "",
        optional: true,
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Makanan",
        type: "text",
        placeholder: "Isi jika memiliki alergi makanan",
        name: "alg_makanan",
        value: "",
        optional: true,
        additional: "",
      },
    ],
  },
];
export let formResiko = [
  {
    colnum: 1,
    columns: [
      {
        label:
          "a. Cara jalan pasien saat akan duduk di kursi tampak tidak seimbang(sempoyongan/limbung)",
        type: "radio",
        placeholder: "",
        name: "rsk_a",
        value: "0",
        defaultValue: "0",
        optional: true,
        options: [
          {
            label: "Ya",
            value: "1",
          },
          {
            label: "Tidak",
            value: "0",
          },
        ],
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label:
          "b. Pasien memegang pinggiran kursi/meja/benda lain saat akan duduk",
        type: "radio",
        placeholder: "",
        name: "rsk_b",
        value: "0",
        defaultValue: "0",
        optional: true,
        options: [
          {
            label: "Ya",
            value: "1",
          },
          {
            label: "Tidak",
            value: "0",
          },
        ],
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Hasil",
        type: "select",
        placeholder: "Pilih hasil skrining resiko",
        name: "tkt_resiko",
        value: "1",
        defaultValue: "1",
        readonly: true,
        mandatory: true,
        multiple: false,
        options: [
          {
            label: "Tidak beresiko ( tidak ditemukan a dan b )",
            value: 1,
          },
          {
            label: "Resiko rendah ( ditemukan a atau b )",
            value: 2,
          },
          {
            label: "Resiko tinggi ( ditemukan a dan b )",
            value: 3,
          },
        ],
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Skala Nyeri",
        type: "radio",
        placeholder: "",
        name: "skala_nyeri",
        value: "0",
        defaultValue: "0",
        optional: true,
        multiple: false,
        options: [
          { value: 0, label: 0 },
          { value: 1, label: 1 },
          { value: 2, label: 2 },
          { value: 3, label: 3 },
          { value: 4, label: 4 },
          { value: 5, label: 5 },
          { value: 6, label: 6 },
          { value: 7, label: 7 },
          { value: 8, label: 8 },
          { value: 9, label: 9 },
          { value: 10, label: 10 },
        ],
        additional: "",
        preHtml: ``,
        postHtml: `<h6 class="mb-0" style="font-weight:500 !important">Keterangan</h6>
        <ul class="pl-3">
          <li>Tidak ada nyeri ( skala 0)</li>
          <li>Nyeri ringan ( skala 1,2,3)</li>
          <li>Nyeri sedang (skala 4,5,6)</li>
          <li>Nyeri berat ( skala 7,8,9,10)</li>
        </ul>`,
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Keluhan Pasien",
        type: "textarea",
        regex: /^.{0,255}$/,
        regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "max. 255 karakter",
        name: "keluhan",
        value: "",
        mandatory: false,
        optional: true,
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "SOAP Perawat",
        type: "textarea",
        regex: /^.{0,255}$/,
        regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "max. 255 karakter",
        name: "soap",
        value: "",
        mandatory: false,
        optional: true,
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Upload Persetujuan Tindakan Kedokteran",
        type: "file",
        placeholder: "",
        name: "file_persetujuan",
        value: "",
        mandatory: false,
        optional: true,
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Upload Penandaan Operasi",
        type: "file",
        placeholder: "",
        name: "file_penandaan_operasi",
        value: "",
        mandatory: false,
        optional: true,
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Upload Serah Terima Pasien",
        type: "file",
        placeholder: "",
        name: "file_serah_terima",
        value: "",
        mandatory: false,
        optional: true,
      },
    ],
  },
];
